import { NotFoundState } from '../components/not-found-state'

/**
 * 404 page for an unrouted URL. Renders inside the AppShell or standalone
 * depending on auth state.
 *
 * The panel itself is the shared `NotFoundState`; this file only supplies
 * the copy for "you typed a URL that does not exist", as distinct from
 * "that member does not exist". Per the MUR "Design Tokens and Accessibility" page (content rules): short,
 * second-person, no jargon, and no echo of the URL that was requested.
 */
export function NotFoundPage(): JSX.Element {
  return (
    // This route renders outside the AppShell, so it supplies its own
    // `<main>`. `NotFoundState` deliberately does not, because the detail
    // page renders it inside the shell where a `<main>` already exists.
    <main id="main" role="main">
      <NotFoundState
        heading="Page not found"
        description="The page you requested does not exist. It may have been moved, or the link may be out of date."
        backTo="/"
        backLabel="Go to the start"
      />
    </main>
  )
}
